import { Progress } from '@backstage/core-components';
import { Team } from '@internal/schemas-common';
import { useMemo } from 'react';

import {
  getSecretsScore,
  scoreRules,
  useGetSecrets,
} from '@internal/backstage-plugin-aws-services';
import { HealthScoreCard, SimpleScore } from '@internal/ui-common';

export const SecretsChart = ({
  teams,
  precalculatedScore,
}: {
  teams?: Team[];
  boardLabel: string;
  precalculatedScore?: SimpleScore | undefined;
}) => {
  const { value: secrets, loading } = useGetSecrets({
    teams,
  });

  const score = useMemo<SimpleScore>(() => {
    if (precalculatedScore) return precalculatedScore;

    if (secrets?.length) {
      return getSecretsScore(secrets);
    }
    return {
      red: 0,
      orange: 0,
      green: 0,
    };
  }, [secrets, precalculatedScore]);

  if (loading) {
    return <Progress />;
  }

  return (
    <HealthScoreCard
      score={score}
      scoreRules={scoreRules}
      trendInfo={{ enabled: false }}
    />
  );
};
